import { makeAutoObservable } from "mobx";
import { IFollowUpQuestionAnswer } from "../../../models/ReturnReasonTypes";
import { ICrmaFollowUpAnswerRequestDto } from "./request-product-store";

export interface ICreateRmaFuqAnswer extends IFollowUpQuestionAnswer {
    translation?: string;
}

class CreateRmaFuqAnswerStore {
    private _is_selected: boolean = false;
    private _translation?: string;
    
    constructor(private _model?:ICreateRmaFuqAnswer, isSelected = false, private _answer?: string ) {
        makeAutoObservable(this, {},{autoBind: true});
        this._is_selected = isSelected;
    }

    get id(): number|null { return this._model?.id ?? null; }
    get isSelected(): boolean { return this._is_selected; }
    get displayName(): string { return this._model?.display_name ?? ''; }
    get answer(): string|undefined { return this._answer; }
    get weight(): number { return this._model?.weight ?? 0; }

    /** we want to save current translation of the answer as part of the answer */
    public setIsSelected(value: boolean, getTranslation?: (k: string) => string): void {
        this._is_selected = value;
        if (getTranslation) {
            this._translation = getTranslation(this.displayName);
        }
    }

    public setAnswer(v: string) {
        this._answer = v;
    }

    public requestModel():ICrmaFollowUpAnswerRequestDto {
        return {
            return_reasons_fuq_answer_id: this.id,
            translation_key: this.displayName,
            translation: this._translation ?? '',
            answer: this.answer,
        }
    };
}

    

export default CreateRmaFuqAnswerStore;